import { z } from 'zod/v4';

import { visualRunRateTypeSchema } from '../operation/enums';

export const columns = {
  bid_rate_category_id: z.string().nullable(),
  description: z.string().nullable(),
  id: z.string(),
  intrastat_include: z.string().nullable(),
  load_size_qty: z.number().nullable(),
  long_description: z.instanceof(Buffer).nullable(),
  minimum_move_qty: z.number().nullable(),
  plan_transit_days: z.number().nullable(),
  rowid: z.number(),
  run: z.number().nullable(),
  run_type: visualRunRateTypeSchema.nullable(),
  schedule_rank: z.number().nullable(),
  service_part_id: z.string().nullable(),
  status: z.string().nullable(),
  status_eff_date: z.date(),
  usage_um: z.string().nullable(),
  vat_code: z.string().nullable(),
  vendor_id: z.string().nullable(),
};
